import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { SpecificationReviewEffects } from './+state/specification-review.effects';
import { specificationReviewFeature } from './+state/specification-review.reducer';

export function provideSpecificationReview(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(specificationReviewFeature),
    provideEffects([SpecificationReviewEffects]),
  ]);
}
